// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 296 ? "ea88be26" : chunkId) + "." + {"296":"6fc2bdc0617142ae","4690":"ad6a435859b5de43","5217":"a062f8d2e61587a6"}[chunkId] + ".js";
};